

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthAPI } from "../api/AuthAPI";


const ResetPassword = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const storedEmail = localStorage.getItem("resetEmail"); // <-- get email
    if (storedEmail) {
      setEmail(storedEmail);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!newPassword || !confirm)
      return setError("Password fields are required.");

    if (newPassword !== confirm)
      return setError("Passwords do not match.");

    const resetToken = localStorage.getItem("resetToken");
    if (!resetToken) return setError("Reset token not found. Try again.");

    try {
      setLoading(true);

      await AuthAPI.reset({
        email,            // <-- include email
        reset_token: resetToken,
        new_password: newPassword,
      });

      localStorage.removeItem("resetToken");
      localStorage.removeItem("resetEmail");

      navigate("/");
    } catch (err) {
      setError(err.response?.data?.message || "Reset failed.");
    } finally {
      setLoading(false);
    }
  };

return (
  <div
    className="min-h-screen flex items-center justify-center bg-cover bg-center"
    style={{
      backgroundImage:
        'url("https://confidays.com/wp-content/uploads/2022/03/M2.png")',
    }}
  >
    <div className="bg-white rounded-xl shadow-lg w-full max-w-sm p-6">
      <h2 className="text-xl font-bold text-center mb-2">
        Reset Password
      </h2>

      <p className="text-sm text-gray-600 text-center mb-4">
        Enter a new password for your account
      </p>

      <form onSubmit={handleSubmit}>
        {/* Email */}
        <label className="block text-sm font-medium mb-1">
          Email address*
        </label>
        <input
          type="email"
          value={email}
          readOnly
          className="w-full border rounded-md px-3 py-2 mb-3 text-sm bg-gray-100"
        />

        {/* New Password */}
        <label className="block text-sm font-medium mb-1">
          New password*
        </label>
        <input
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className="w-full border rounded-md px-3 py-2 mb-3 text-sm"
          required
        />

        {/* Confirm Password */}
        <label className="block text-sm font-medium mb-1">
          Confirm password*
        </label>
        <input
          type="password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          className="w-full border rounded-md px-3 py-2 mb-3 text-sm"
          required
        />

        {error && (
          <p className="text-red-500 text-xs text-center mb-2">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-900 hover:bg-blue-800 text-white py-2 rounded-md text-sm font-medium"
        >
          {loading ? "Resetting..." : "Reset Password →"}
        </button>
      </form>
    </div>
  </div>
);

};

export default ResetPassword;


